import { createFileRoute, useRouter } from '@tanstack/react-router';
import { useFlow } from '@/mosaic-modules/useFlow';

export const Route = createFileRoute('/{-$locale}/offer')({
  component: OfferDetailsPage,
});

interface OfferDetailsFlowProps {
  title: string;
}

function OfferDetailsPage() {
  const router = useRouter();
  const flowProps = useFlow<OfferDetailsFlowProps>(
    'offers-module',
    'offer-details',
  );
  if (!flowProps) return null;

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
      <button type="button" onClick={() => router.history.back()}>
        &larr;
      </button>
      <h1>{flowProps.title}</h1>
    </div>
  );
}
